export const ENABLE_OTP_LOGIN = 'urn:zillow:email_otp';
export const SUPPORTED_LOGIN_FLAG = 'acr_values';

export const LOCATION_REQUESTED_SESSION_STORAGE_KEY = 'HomeLoansDashboard|SignInRequest|Location';

export const AUTH0_IDP_IDENTIFIER = 'zhl-home-loans-dashboard';
export const AUTH0_IDP_IDENTIFIER_KEY = 'ext-entry_point';
